@if (title) {
  <div class="header">{{ title }}</div>
}
<ng-content></ng-content>
